// @ts-nocheck

import { withTranslation } from 'react-i18next';
import React, { Fragment, memo } from 'react';
import RET from './RET/RET.tsx';
import BarcodeImage from './image/image.tsx';

type Props = {
  itemTicket: TicketModel | ProductModel;
};

const RotatingOrStaticBarcode = ({ itemTicket }: Props) => {
  const { isSecureEntry, barcode, rotatingEntryToken, renderType } = itemTicket;

  return (
    <Fragment>
      {isSecureEntry && rotatingEntryToken && <RET token={rotatingEntryToken} id={`ret${itemTicket.id}BarcodeId`} />}
      {(!isSecureEntry || !rotatingEntryToken) && (
        <BarcodeImage barcodeValue={barcode} barcodeType={renderType} isSecureEntry={isSecureEntry} />
      )}
    </Fragment>
  );
};

export default withTranslation('translation')(memo(RotatingOrStaticBarcode));
